<template class="formDialog">
  <v-dialog
    v-model="dialog"
    max-width="1000px"
    :persistent="true"
  >
    <v-form
      ref="form"
      v-model="valid"
    >
      <v-card class="pa-4">
        <v-card-title>
          <v-icon
            style="font-size: 35px; color: #43BA7E;"
            class="mr-2"
          >
            mdi-qrcode
          </v-icon>
          <h2>
            New QR Code -
            {{ qrCodeNumber }}
          </h2>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-column ga-3">
            <div class="d-flex align-center ga-2 pb-2 pt-2">
              <v-icon style="font-size: 30px; color: #3F76D4;">
                mdi-package-variant-closed
              </v-icon>
              <h2 style="color: #000">
                Item Information
              </h2>
            </div>
            <div class="d-flex flex-wrap ga-3">
              <inventory-class-select-element
                v-model="inventoryClassId"
                :is-add-all="false"
                :is-required="true"
                :is-inst="false"
                :is-parts="false"
                :is-paint="false"
                :is-patio-door="false"
                :disabled="data != null"
                style="max-width: 220px;"
              />
              <v-autocomplete
                v-model="inventoryItemId"
                :items="inventoryItems"
                item-value="id"
                :loading="loadingInventoryItem"
                :item-text="
                  (item) => item.material_id + ': ' + item.name
                "
                :rules="[validateInventoryItem]"
                no-data-text="Select a Class first"
                :disabled="data != null"
              >
                <template slot="label">
                  Inventory Item<RedAsterisk />
                </template>
                <template #item="{ item }">
                  <v-chip
                    class="mt-1 mb-1 mr-3"
                    small
                    text-color="white"
                    style="cursor: pointer;"
                    :color="item && item.classes ? item.classes.color : 'white'"
                  >
                    {{ item && item.classes ? item.classes.name : '' }}
                  </v-chip><span style="font-weight: bold; font-size: 20px">{{ item.material_id }}</span><span style="font-size: 20px">{{ ': ' + item.name }}</span>
                </template>
                <!-- eslint-disable-next-line vue/no-template-shadow -->
                <template #selection="{ item }">
                  <v-chip
                    class="mt-1 mb-1 mr-3"
                    small
                    text-color="white"
                    style="cursor: pointer;"
                    :color="item && item.classes ? item.classes.color : 'white'"
                  >
                    {{ item && item.classes ? item.classes.name : '' }}
                  </v-chip><span style="font-weight: bold; font-size: 20px">{{ item.material_id }}</span><span style="font-size: 20px">{{ ': ' + item.name }}</span>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId !== inventoryClassIdGlass && inventoryClassId !== inventoryClassIdVWDGlass && inventoryClassId !== inventoryClassIdPanels && inventoryClassId !== inventoryClassIdSID && inventoryClassId !== inventoryClassIdPatioDoor && inventoryClassId !== inventoryClassIdEquipment"
                v-model="length"
                :items="lengths"
                auto-select-first
                :loading="loadingLength"
                item-text="name"
                item-value="id"
                style="max-width: 200px;"
              >
                <template slot="label">
                  Length
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdPanels"
                v-model="dimensionUnitId"
                :items="dimensionUnits"
                auto-select-first
                :loading="loadingDimensionUnit"
                item-text="name"
                item-value="id"
                style="max-width: 200px;"
                :disabled="data != null"
              >
                <template slot="label">
                  Dimension Unit
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-else-if="inventoryClassId === inventoryClassIdSID"
                v-model="doorSizeId"
                :items="doorSizes"
                item-text="name"
                item-value="id"
                no-data-text="Select an Inventory Item first"
                :rules="[(v) => !!v || 'Size is required']"
              >
                <template slot="label">
                  Size<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="uom"
                :items="uoms"
                auto-select-first
                item-text="name"
                item-value="id"
                :loading="loadingUom"
                :disabled="data != null"
                style="max-width: 200px;"
              >
                <template slot="label">
                  UOM
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId !== inventoryClassIdGlass && inventoryClassId !== inventoryClassIdVWDGlass && inventoryClassId !== inventoryClassIdSID && inventoryClassId !== inventoryClassIdPatioDoor && inventoryClassId !== inventoryClassIdEquipment"
                v-model="color"
                :items="colorsList"
                :loading="loadingColor"
                item-text="code"
                item-value="id"
                :clearable="true"
                :rules="isReceivingNewTagColorRequired ? [(v) => !!v || 'Color is required'] : []"
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template slot="label">
                  Color<RedAsterisk v-if="isReceivingNewTagColorRequired" />
                </template>
              </v-autocomplete>
              <v-text-field
                v-if="inventoryClassId === inventoryClassIdPatioDoor"
                v-model="height"
                :rules="[(v) => !!v || 'Door height is required']"
              >
                <template slot="label">
                  Door Height<RedAsterisk />
                </template>
              </v-text-field>
              <v-text-field
                v-if="inventoryClassId === inventoryClassIdPatioDoor"
                v-model="width"
                :rules="[(v) => !!v || 'Door width is required']"
              >
                <template slot="label">
                  Door Width<RedAsterisk />
                </template>
              </v-text-field>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdPatioDoor"
                v-model="color"
                :items="colorsList"
                :loading="loadingColor"
                item-text="code"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Interior Color is required']"
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template slot="label">
                  Interior Color<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdPatioDoor"
                v-model="exColor"
                :items="colorsList"
                :loading="loadingColor"
                item-text="code"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Exterior Color is required']"
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template slot="label">
                  Exterior Color<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdSID && (inventoryItemId === inventoryIdSlab || inventoryItemId === inventoryIdInsertF)"
                v-model="doorHingeId"
                :items="doorHinges"
                item-text="name"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Hinge is required']"
              >
                <template slot="label">
                  Hinge<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdSID && (inventoryItemId === inventoryIdSlab || inventoryItemId === inventoryIdInsertF)"
                v-model="doorSwingId"
                :items="doorSwings"
                item-text="name"
                item-value="id"
                :clearable="true"
              >
                <template slot="label">
                  Swing
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdSID && inventoryItemId === inventoryIdInsert"
                v-model="doorLiteId"
                :items="doorLites"
                item-text="name"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Lite is required']"
              >
                <template slot="label">
                  Lite<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-select
                v-if="inventoryClassId === inventoryClassIdRailings || inventoryClassId === inventoryClassIdRailParts || inventoryClassId === inventoryClassIdPanels"
                v-model="paintOnOptionId"
                :items="paintOnOptions"
                item-text="name"
                item-value="id"
                :clearable="true"
                label="Paint On"
              />
              <v-radio-group
                v-if="inventoryClassId === inventoryClassIdSID"
                v-model="isPainted"
                class="w100 mt-0"
                hide-details
              >
                <template #label>
                  <span style="font-size: 1.2em; color: rgba(0, 0, 0, 0.65);">Paint</span>
                </template>
                <v-row>
                  <v-col cols="auto">
                    <v-radio
                      label="PAINTED"
                      :value="1"
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-radio
                      label="NON-PAINTED"
                      :value="0"
                    />
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-radio-group
                v-if="inventoryClassId === inventoryClassIdPatioDoor"
                v-model="doorScreenId"
                :rules="[(v) => !!v || 'Door screen selection is required']"
              >
                <template #label>
                  <span style="font-size: 1.2em; color: rgba(0, 0, 0, 0.65);">Screen<RedAsterisk /></span>
                </template>
                <v-row>
                  <v-col cols="auto">
                    <v-radio
                      label="WITH SCREEN"
                      :value="1"
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-radio
                      label="WITHOUT SCREEN"
                      :value="2"
                    />
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-radio-group
                v-if="inventoryClassId === inventoryClassIdPatioDoor"
                v-model="isFritted"
                :rules="[(v) => (v !== null && v !== undefined && v !== '') || 'Fritted or Non-Fritted selection is required']"
              >
                <template #label>
                  <span style="font-size: 1.2em; color: rgba(0, 0, 0, 0.65);">Fritted<RedAsterisk /></span>
                  <!-- <span style="font-size: .8em; color: rgba(0, 0, 0, 0.65);" v-if="!!glass"> (auto selected from Glass)</span> -->
                </template>
                <v-row>
                  <v-col cols="auto">
                    <v-radio
                      label="FRITTED"
                      :value="1"
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-radio
                      label="NON-FRITTED"
                      :value="0"
                    />
                  </v-col>
                </v-row>
              </v-radio-group>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdSID && isPainted == 1"
                v-model="color"
                :items="colorsList"
                :loading="loadingColor"
                item-text="code"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || `${inventoryItemId !== inventoryIdSweep ? 'Interior Color' : 'Color'} is required`]"
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template slot="label">
                  {{ inventoryItemId !== inventoryIdSweep ? 'Interior Color' : 'Color' }}<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdSID && isPainted == 1 && inventoryItemId !== inventoryIdSweep"
                v-model="exColor"
                :items="colorsList"
                :loading="loadingColor"
                item-text="code"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Exterior Color is required']"
              >
                <template #selection="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    {{ item.code }}
                  </span>
                </template>
                <template slot="label">
                  Exterior Color<RedAsterisk />
                </template>
              </v-autocomplete>
            </div>
            <div class="d-flex align-center ga-2 pb-2">
              <v-icon style="font-size: 30px; color: purple;">
                mdi-map-marker-outline
              </v-icon>
              <h2 style="color: #000">
                Location & Storage
              </h2>
            </div>
            <div class="d-flex flex-wrap ga-3">
              <v-autocomplete
                v-if="isShowLocation"
                v-model="locationId"
                :items="locationsList"
                :loading="loadingLocation"
                auto-select-first
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Location is required']"
              >
                <template slot="label">
                  Location<RedAsterisk />
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="shelfId"
                :items="inventoryLocations"
                :loading="loadingShelf"
                item-text="name"
                item-value="id"
                :clearable="true"
                :rules="[(v) => !!v || 'Shelf is required']"
              >
                <template slot="label">
                  Shelf<RedAsterisk />
                </template>
              </v-autocomplete>
            </div>
            <div class="d-flex align-center ga-2 pb-2">
              <v-icon style="font-size: 30px; color: red;">
                mdi-truck-outline
              </v-icon>
              <h2 style="color: #000">
                Order & Supply Information
              </h2>
            </div>
            <div class="d-flex flex-wrap ga-3">
              <v-autocomplete
                v-if="isShowPO"
                v-model="po_number"
                :items="inventoryPos"
                :clearable="true"
                label="PO#"
                :rules="!isCurrentPhysicalCountClassesMatchInventoryClassSelection ? [(v) => !!v || 'PO# is required'] : []"
                :disabled="data != null"
              >
                <template slot="label">
                  PO#<RedAsterisk v-if="!isCurrentPhysicalCountClassesMatchInventoryClassSelection" />
                </template>
              </v-autocomplete>
              <v-text-field
                v-model="quantity"
                :rules="[(v) => !!v || 'Quantity is required', (v) => /^\d+$/.test(v) || 'Please enter a whole number']"
                type="number"
                step="1"
                min="0"
              >
                <template slot="label">
                  Quantity<RedAsterisk />
                </template>
              </v-text-field>
              <v-file-input
                v-if="inventoryClassId === inventoryClassIdGlass || inventoryClassId === inventoryClassIdVWDGlass"
                v-model="supplierLabel"
                accept="image/*"
                capture="user"
                label="Supplier Label"
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Supplier Label Photo is required']"
                style="min-width: 300px;"
              >
                <template slot="label">
                  Supplier Label<RedAsterisk />
                </template>
              </v-file-input>
              <v-text-field
                v-if="inventoryClassId === inventoryClassIdGlass || inventoryClassId === inventoryClassIdVWDGlass"
                v-model="batchNumber"
                :rules="[(v) => !!v || 'Vendor Batch# is required']"
              >
                <template slot="label">
                  Vendor Batch#<RedAsterisk />
                </template>
              </v-text-field>
              <v-menu
                v-if="inventoryClassId === inventoryClassIdGlass || inventoryClassId === inventoryClassIdVWDGlass"
                ref="menu"
                v-model="dateMenu"
                :return-value.sync="productionDate"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    v-model="productionDate"
                    label="Date"
                    readonly
                    v-bind="attrs"
                    :rules="[(v) => !!v || ' Production Date is required']"
                    v-on="on"
                    @change="$refs.menu.save(productionDate)"
                  >
                    <template slot="label">
                      Production Date<RedAsterisk />
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="productionDate"
                  no-title
                  scrollable
                >
                  <v-spacer />
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="productionDate = null"
                  >
                    Clear
                  </v-btn>
                </v-date-picker>
              </v-menu>
              <v-autocomplete
                v-if="inventoryClassId !== inventoryClassIdPatioDoor && inventoryClassId !== inventoryClassIdEquipment"
                v-model="projectId"
                :items="projects"
                item-text="name"
                item-value="id"
                :clearable="true"
                label="Project"
                :disabled="data != null"
              />
              <v-autocomplete
                v-if="inventoryClassId === inventoryClassIdSID"
                v-model="supplierId"
                :items="suppliers"
                :item-text="(item) => `${item.code} ${item.name}`"
                item-value="id"
                :clearable="true"
                label="Supplier"
              >
                <template #selection="{ item }">
                  <span>
                    <span class="font-weight-bold">{{ item.code }}</span>
                    {{ item.name }}
                  </span>
                </template>
                <template #item="{ item }">
                  <span>
                    <span class="font-weight-bold">{{ item.code }}</span>
                    {{ item.name }}
                  </span>
                </template>
              </v-autocomplete>
            </div>
            <v-row>
              <v-col
                md="12"
                sm="12"
              >
                <v-row>
                  <v-col
                    class="pb-0"
                  >
                    <span style="font-size: 18px;">Note</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="pt-0"
                  >
                    <v-textarea
                      v-model="noteText"
                      outlined
                      rows="3"
                      placeholder="Enter any additional notes or special instructions here..."
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            large
            color="normal"
            class="mr-2"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
          <v-btn
            large
            color="primary"
            @click="submitForm"
          >
            {{ btnSubmitName }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import * as ValidationHelpers from '@/helpers/ValidationHelpers';

export default {
  components: {
  },
  props: {
    enteredTag: {
      type: String,
      default: '',
    },
    isShowPO: {
      type: Boolean,
      default: false,
    },
    isShowLocation: {
      type: Boolean,
      default: false,
    },
    defaultLocation: {
      type: Object,
      default: () => {},
    },
    defaultShelf: {
      type: Object,
      default: () => {},
    },
    defaultQuantity: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    // Inventory Item
    uom: null,
    length: null,
    color: null,
    inventoryTag: null,
    inventoryItemId: null,
    shelfId: null,
    quantity: null,
    userId: null,
    po_number: null,
    locationId: null,
    isQrEqualsTag: 0,
    qrCodeNumber: '',
    inventoryClassId: null,
    supplierLabel: null,
    batchNumber: null,
    doorSizeId: null,
    doorHingeId: null,
    doorSwingId: null,
    doorLiteId: null,
    height: null,
    width: null,
    doorScreenId: 1,
    isFritted: 1,
    isPainted: 0,
    // glass: null,
    exColor: null,
    projectId: null,
    supplierId: null,
    paintOnOptionId: null,
    dimensionUnitId: null,
    productionDate: new Date().toISOString().slice(0, 10),
    inventoryClassId4500: 1,
    inventoryClassId4800: 2,
    inventoryClassIdRailings: 3,
    inventoryClassIdGlass: 5,
    inventoryClassIdVWDGlass: 7,
    inventoryClassIdPanels: 8,
    inventoryClassIdSID: 9,
    inventoryClassIdPanelParts: 10,
    inventoryClassIdRailParts: 10,
    inventoryClassIdEquipment: 13,
    inventoryClassIdPatioDoor: 14,
    inventoryClassId6000: 18,
    glassCodeTypeIdSealedUnit: 2,

    inventoryIdSlab: 1100,
    inventoryIdSweep: 1101,
    inventoryIdInsert: 1102,
    inventoryIdInsertF: 4058,
    noteText: null,

    loadingInventoryItem: false,
    loadingLength: false,
    loadingUom: false,
    loadingDimensionUnit: false,
    loadingColor: false,
    loadingLocation: false,
    loadingShelf: false,
    // loadingGlassCodes: false,
    // Inventory
    lengths: [],
    uoms: [],
    dimensionUnits: [],
    colorsList: [],
    inventoryItems: [],
    inventoryLocations: [],
    locationsList: [],
    doorHinges: [],
    doorSwings: [],
    doorLites: [],
    doorSizes: [],
    projects: [],
    suppliers: [],
    inventoryPos: [],
    paintOnOptions: [],
    // glassCodes: [],

    // Form
    dialog: false,
    dialogTitle: '',
    valid: false,
    btnSubmitName: 'ADD',
    dateMenu: false,
    data: null,

  }),
  computed: {
    ...mapGetters([
      'businessRulesGetBoolean',
      'isPhysicalCountActivated',
      'currentPhysicalCount',
    ]),
    ...mapState({
      user: 'user',
    }),
    isCurrentPhysicalCountClassesMatchInventoryClassSelection() {
      if (!this.isPhysicalCountActivated || !this.currentPhysicalCount || !this.currentPhysicalCount.classes) {
        return false;
      }
      return this.currentPhysicalCount.classes.some((c) => c.id === this.inventoryClassId);
    },
    isReceivingNewTagColorRequired() {
      const receivingColorRequiredClassIds = [
        this.inventoryClassId4500,
        this.inventoryClassId4800,
        this.inventoryClassId6000,
      ];

      return receivingColorRequiredClassIds.includes(this.inventoryClassId);
    },
  },
  watch: {
    enteredTag(value) {
      if (this.isQrEqualsTag) { this.inventoryTag = value; }

      this.qrCodeNumber = value;
    },
    inventoryClassId() {
      // this.$refs.form.reset();
      this.fetchInventoryItems();
    },
    inventoryItemId() {
      if (this.inventoryClassId === this.inventoryClassIdSID) {
        this.getDoorSizes();
      }
      this.getUoms();
      this.getLengths();
      this.getInventoryPos();
    },
    locationId(value) {
      if (!value) return;
      this.fetchInventoryLocations();
    },
    productionDate(val) {
      this.$refs.menu.save(val);
    },
  },
  created() {
    const QrEqualsTagBRName = 'QR Code Equals Inv. Tag';
    this.isQrEqualsTag = this.businessRulesGetBoolean(QrEqualsTagBRName);

    this.initialize();
  },
  methods: {
    async initialize() {
      this.getUoms();
      this.fetchColors();
      this.getLengths();
      this.fetchInventoryItems();
      this.fetchLocations();
      this.fetchInventoryLocations();
      this.getDoorHinges();
      this.getDoorSwings();
      this.getDoorLites();
      this.getProjects();
      this.getSuppliers();
      this.getInventoryPos();
      this.getPaintOnOptions();
      this.getDimensionUnits();

      if (!this.user) return;
      this.userId = this.user.id;
    },
    async getUoms() {
      this.loadingUom = true;
      const submitData = {
        filters:
        {
          inventory_item_id: this.inventoryItemId,
        },
      };
      this.uoms = await this.$api.uom.read(submitData);
      this.loadingUom = false;
    },
    async getDimensionUnits() {
      this.loadingDimensionUnit = true;
      const uomCategoryIdArea = 2;
      const submitData = {
        filters: {
          uom_category_id: uomCategoryIdArea,
        },
      };
      this.dimensionUnits = await this.$api.uom.read(submitData);
      this.loadingDimensionUnit = false;
      if (this.dimensionUnits.length === 1) {
        this.dimensionUnitId = this.dimensionUnits[0].id;
      }
    },
    async fetchColors() {
      this.loadingColor = true;
      const submitModel = {
        filters: {
        },
      };

      this.colorsList = await this.$api.color.read(submitModel);
      this.loadingColor = false;
    },
    async getLengths() {
      this.loadingLength = true;
      const submitData = {
        filters:
        {
          inventory_item_id: this.inventoryItemId,
          inventory_class_id: this.inventoryClassId,
        },
      };
      this.lengths = await this.$api.length.read(submitData);
      this.loadingLength = false;
    },
    async fetchInventoryItems() {
      if (!this.inventoryClassId) return;
      this.loadingInventoryItem = true;
      this.inventoryItems = [];
      const readModel = {
        filters:
        {
          inventory_class_id: this.inventoryClassId,
        },
      };

      const res = await this.$api.inventoryItem.readData(readModel);
      this.loadingInventoryItem = false;
      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.inventoryItems = [];
        return;
      }
      this.inventoryItems = res.data;
    },
    async fetchInventoryLocations() {
      this.loadingShelf = true;
      const readModel = {
        filters:
        {
          location_id: this.locationId,
        },
      };
      this.inventoryLocations = await this.$api.inventoryLocation.read(readModel);
      this.loadingShelf = false;
    },

    async fetchLocations() {
      this.loadingLocation = true;
      this.locationsList = await this.$api.location.getList();
      this.loadingLocation = false;
    },

    async getDoorHinges() {
      this.doorHinges = await this.$api.doorHinge.getList();
    },

    async getDoorSwings() {
      this.doorSwings = await this.$api.doorSwing.getList();
    },

    async getDoorLites() {
      this.doorLites = await this.$api.doorLite.getList();
    },

    async getDoorSizes() {
      this.doorSizes = await this.$api.doorSize.get(`${this.inventoryItemId}`);
    },

    async getPaintOnOptions() {
      this.paintOnOptions = await this.$api.paintOnOption.get();
    },

    async getProjects() {
      const submitModel = {
        filters: {
          is_all: 1,
        },
      };
      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) { return; }
      if (!res || !res.data) {
        return;
      }
      this.projects = res.data;
    },

    async getSuppliers() {
      const submitModel = {
        filters: {
          inventory_classes: [this.inventoryClassIdSID],
        },
      };
      const res = await this.$api.supplier.read(submitModel);
      if (!res || !res.data) {
        this.suppliers = [];
        return;
      }
      this.suppliers = res.data;
    },

    async getInventoryPos() {
      const inventoryClassIdFilter = this.inventoryClassId === this.inventoryClassIdRailParts ? [this.inventoryClassIdRailParts, this.inventoryClassIdRailings] : this.inventoryClassId;
      const submitModel = {
        filters: {
          inventory_class_id: inventoryClassIdFilter,
        },
      };
      const res = await this.$api.inventoryPo.read(submitModel, null, 'read-simple');
      if (!res) {
        return;
      }
      this.inventoryPos = res;
    },

    async submitForm() {
      if (this.inventoryClassId === this.inventoryClassIdPatioDoor && (!this.isDecimalInFractions(this.width) || !this.isDecimalInFractions(this.height))) {
        this.$bus.$emit('showError', 'Incorrect Width or Height value');
        return;
      }

      if (!this.validateFields()) {
        return;
      }

      const isFormValid = this.$refs.form.validate();
      if (!isFormValid) {
        return;
      }

      if (this.isPhysicalCountActivated) {
        // if physical count is activated then if po_number is selected, then we need to query the inventory po and find the inventory po item associated with the currently selected parameters
        if (this.po_number) {
          const submitData = {
            filters: {
              po_number: this.po_number,
              inventory_item_id: this.inventoryItemId,
              uom_id: this.uom,
              length_id: this.length,
              dimension_unit_id: this.dimensionUnitId,
              color_id: this.color,
            },
          };

          const res = await this.$api.inventoryPoItem.read(submitData);
          if (!res || res.length === 0) {
            this.$bus.$emit('showError', 'No matching PO Item found for the selected parameters');
            return;
          }

          // set inventory_po_item_id in data
          this.data = this.data || {};
          this.data.inventory_po_item_id = res[0].id;
          this.data.inventory_po_id = res[0].inventory_po_id;
        }
      }

      if (isFormValid) {
        this.$bus.$emit('loading');
        const data = new FormData();

        // Qr Code is treated as inv tag for now
        if (this.qrCodeNumber) {
          data.append('inventory_tag', this.qrCodeNumber);
        }

        if (this.inventoryItemId) {
          data.append('inventory_item_id', this.inventoryItemId);
        }

        if (this.uom) {
          data.append('uom_id', this.uom);
        }

        if (this.length) {
          data.append('length_id', this.length);
        }

        if (this.color) {
          data.append('color_id', this.color);
        }

        if (this.shelfId) {
          data.append('inventory_location_id', this.shelfId);
        }

        if (this.quantity) {
          data.append('quantity', this.quantity);
        }
        if (this.user.id) {
          data.append('created_by', this.user.id);
        }

        if (this.po_number) {
          data.append('po_number', this.po_number);
        }

        if (this.locationId) {
          data.append('location_id', this.locationId);
        }

        if (this.supplierLabel) {
          data.append('supplier_label', this.supplierLabel);
        }

        if (this.batchNumber) {
          data.append('batch_number', this.batchNumber);
        }

        if (this.productionDate) {
          data.append('production_date', this.productionDate);
        }

        if (this.doorHingeId) {
          data.append('door_hinge_id', this.doorHingeId);
        }

        if (this.doorSwingId) {
          data.append('door_swing_id', this.doorSwingId);
        }

        if (this.doorLiteId) {
          data.append('door_lite_id', this.doorLiteId);
        }

        if (this.doorSizeId) {
          data.append('door_size_id', this.doorSizeId);
        }

        if (this.isPainted) {
          data.append('is_painted', this.isPainted);
        }

        if (this.exColor) {
          data.append('ex_color_id', this.exColor);
        }

        if (this.noteText) {
          data.append('note_text', this.noteText);
        }

        if (this.projectId) {
          data.append('project_id', this.projectId);
        }

        if (this.supplierId) {
          data.append('supplier_id', this.supplierId);
        }

        if (this.height) {
          data.append('height', this.height);
        }

        if (this.width) {
          data.append('width', this.width);
        }

        if (this.isFritted !== undefined && this.isFritted !== null) {
          data.append('is_fritted', this.isFritted);
        }

        if (this.doorScreenId) {
          data.append('door_screen_id', this.doorScreenId);
        }

        if (this.paintOnOptionId) {
          data.append('paint_on_option_id', this.paintOnOptionId);
        }

        if (this.dimensionUnitId) {
          data.append('dimension_unit_id', this.dimensionUnitId);
        }

        if (this.data && this.data.inventory_po_item_id) {
          data.append('inventory_po_item_id', this.data.inventory_po_item_id);
        }

        // if (this.glass) {
        //   data.append('glass', this.glass);
        // }

        const res = await this.$api.inventoryTag.addTag(data);
        if (!res) {
          this.$bus.$emit('showError');
          this.$bus.$emit('loading-stop');
          return;
        }

        if (this.po_number) {
          // const submitData = {
          //   inventory_po_id: this.data ? this.data.inventory_po_id : null,
          //   packaging_slip: this.data ? this.data.packaging_slip : null,
          // };

          // const resPo = await this.$api.inventoryPoItem.store(submitData, 'receiving');

          const submitData = new FormData();

          if (this.data.inventory_po_id) {
            submitData.append('inventory_po_id', this.data.inventory_po_id);
          }

          if (this.data.packaging_slip) {
            submitData.append('packaging_slip', this.data.packaging_slip);
          }

          if (this.data.packaging_slip_img) {
            submitData.append('packaging_slip_img', this.data.packaging_slip_img);
          }

          const resPo = await this.$api.inventoryPoItem.store(submitData, 'receiving');

          if (!resPo) {
            this.$bus.$emit('showError');
            this.$bus.$emit('loading-stop');
            return;
          }
        }

        this.$bus.$emit('loading-stop');
        this.$emit('submitQRCodeTag', 'QR Code has been added to ERP');
        this.data = null;
        this.closeDialog();
      }
    },

    async openDialog(data) {
      if (this.$refs.form) await this.$refs.form.reset();
      this.dialog = true;
      if (this.isQrEqualsTag) { this.inventoryTag = this.enteredTag; }

      this.qrCodeNumber = this.enteredTag;

      // set default values

      // UOM
      if (this.uoms.length) {
        const uomIdPcs = 1;
        const uom = this.uoms.find((x) => x.id === uomIdPcs);
        if (uom) { this.uom = uom.id; } else { this.uom = 0; }
      } else { this.uom = 0; }

      // Length
      if (this.lengths.length) {
        const length = this.lengths.find((x) => x.name === '16 ft.');
        if (length && length.id) { this.length = length.id; } else { this.length = 0; }
      } else { this.length = 0; }

      // Location
      // If is set prop defaultLocation
      // else get first record from the list
      if (this.defaultLocation) {
        this.locationId = this.defaultLocation.id;
      } else if (this.locationsList.length && this.locationsList[0].id) {
        const locationId = this.locationsList[0].id;
        if (locationId) { this.locationId = locationId; } else { this.locationId = 0; }
      } else { this.locationId = 0; }

      // Shelf
      // If is set prop defaultShelf
      if (this.defaultShelf) {
        this.shelfId = this.defaultShelf.id;
      }

      // Quantity
      // If is set prop defaulQuantity
      if (this.defaultQuantity) {
        this.quantity = this.defaultQuantity;
      }

      if (data) {
        this.inventoryClassId = data.inventory_class_id || null;
        this.inventoryItemId = data.inventory_item_id || null;
        this.uom = data.uom_id || null;
        this.length = data.length_id || null;
        this.color = data.color_id || null;
        this.po_number = data.po_number || null;
        this.projectId = data.project_id || null;
        this.locationId = data.location_id || null;
        this.dimensionUnitId = data.dimension_unit_id || null;
        this.data = data;
      }
    },

    validateFields() {
      const inventoryItemValidation = this.validateInventoryItem(this.inventoryItemId);
      if (inventoryItemValidation !== true) {
        this.$bus.$emit('showError', inventoryItemValidation);
        return false;
      }

      return true;
    },

    validateInventoryItem(value) {
      const hasValue = value !== null && value !== undefined && value !== '';
      if (!hasValue) {
        return 'Inventory Item is required';
      }

      const inventoryItemExists = this.inventoryItems.some((item) => item && String(item.id) === String(value));
      return inventoryItemExists || 'Inventory Item no longer exists';
    },

    closeDialog() {
      this.dialog = false;
    },

    isDecimalInFractions(decimalNumber) {
      return ValidationHelpers.isDecimalInFractions(decimalNumber);
    },
  },
};
</script>

<style scoped>
.mrp-btn-add {
  min-width: 35px !important;
  padding: 0 !important;
}
.v-text-field >>> input {
    font-size: 1.5em !important;
}
.v-autocomplete >>> input{
    font-size: 1.5em !important;
}
.v-autocomplete >>> label{
    font-size: 1.1em !important;
}
.v-text-field >>> label {
    font-size: 1.1em !important;
}
.v-btn {
    font-size: 1.1em !important;
}
/* v-autocomplete highlight color */
.theme--light.v-list-item .v-list-item__mask {
    background: #e6e90a !important;
}
</style>
